export const SCHEDULE_BUSINESS_STATUS = {
  PENDING: "Pending",
  UPCOMING: "Upcoming",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export function resolveScheduleStatusName(row) {
  return String(row?.status_name ?? "").trim();
}

export function canMarkScheduleCompleted(row) {
  const name = resolveScheduleStatusName(row).toLowerCase();
  return name === "pending" || name === "upcoming";
}

export function canCancelSchedule(row) {
  const name = resolveScheduleStatusName(row).toLowerCase();
  return name === "pending" || name === "upcoming";
}
